module.exports = __webpack_public_path__ + "img/TAB_02_Passive.88fa145d.svg";